// © Microsoft Corporation. All rights reserved.

import { TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";

export interface CommentListTelemetryObjects {
    mainItem: TelemetryObjectBase
}

export const commentListTelemetryContracts = {
    mainItem: {
        name: "Comment",
        content: {
            type: TelemetryContentType.Comment
        }
    }
};